import { NavLink } from "react-router-dom";
import { Users, UserCog, Settings, GraduationCap, UserPlus, BookOpen, Settings2, Wallet, Landmark, Percent, ClipboardCheck } from "lucide-react";
import { LAYOUT } from "@/constants/testIds";
import { useAuth } from "@/contexts/AuthContext";
import { hasAcademyAccess } from "@/lib/academyAccess";

const NAV_ITEMS = [
  { key: "academia", label: "Inicio", path: "/academia", icon: GraduationCap, academy: [], end: true },
  { key: "academia-interesados", label: "Interesados", path: "/academia/interesados", icon: UserPlus, academy: ["executive"] },
  { key: "academia-alumnos", label: "Alumnos", path: "/academia/alumnos", icon: Users, academy: [] },
  { key: "academia-cursos", label: "Cursos y fechas", path: "/academia/cursos", icon: BookOpen, academy: [] },
  { key: "academia-practicas", label: "Prácticas", path: "/academia/practicas", icon: ClipboardCheck, academy: ["reception", "academic", "instructor"] }, // Fix D (2026-10-18)
  { key: "academia-caja", label: "Caja", path: "/academia/caja", icon: Wallet, academy: ["reception", "finance"] },
  { key: "academia-finanzas", label: "Finanzas", path: "/academia/finanzas", icon: Landmark, academy: ["finance"] },
  { key: "academia-comisiones", label: "Comisiones", path: "/academia/comisiones", icon: Percent, academy: ["executive", "finance", "instructor"] },
  { key: "academia-configuracion", label: "Config. academia", path: "/academia/configuracion", icon: Settings2, academy: ["finance"] },
  { key: "equipo", label: "Equipo", path: "/equipo", icon: UserCog, roles: ["admin"], section: "Administración" },
  { key: "configuracion", label: "Configuración", path: "/configuracion", icon: Settings, roles: ["admin"] },
];

function canSee(item, user) {
  if (!user) return true;
  return item.academy ? hasAcademyAccess(user, item.academy) : item.roles.includes(user.role);
}

export default function Sidebar({ onNavigate }) {
  const { user } = useAuth();
  const items = NAV_ITEMS.filter((item) => canSee(item, user));

  return (
    <div className="h-full flex flex-col bg-[#E9F3F3]">
      <div className="px-6 py-7">
        <h1 className="font-serif text-2xl tracking-[0.15em] text-brand">AAME</h1>
        <p className="text-xs text-muted-foreground tracking-wide mt-0.5">Academy</p>
      </div>
      <nav className="flex-1 px-3 space-y-1 overflow-y-auto">
        {items.map((item, idx) => (
          <div key={item.key}>
            {item.section && (
              <p className={`px-3 pb-1 text-[10px] uppercase tracking-[0.15em] text-muted-foreground/70 ${idx > 0 ? "pt-4" : ""}`} data-testid={LAYOUT.sidebarAcademySection}>{item.section}</p>
            )}
            <NavLink
              to={item.path}
              end={Boolean(item.end)}
              onClick={onNavigate}
              data-testid={`${LAYOUT.sidebarNavPrefix}${item.key}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-sans transition-colors duration-200 ${
                  isActive
                    ? /* Fix G (2026-10-19) */ "bg-white text-brand font-medium shadow-sm"
                    : "text-muted-foreground hover:bg-white hover:text-foreground"
                }`
              }
            >
              <item.icon className="w-4 h-4 shrink-0" />
              {item.label}
            </NavLink>
          </div>
        ))}
      </nav>
    </div>
  );
}
